import about from './modules/about';
import accounts from './modules/accounts';
import catalog from './modules/catalog';
import mainPage from './modules/mainPage';
import news from './modules/news';
import profile from './modules/profile';
import renters from './modules/toRenters';
import settings from './modules/settings';
import toBusiness from './modules/toBusiness';
import user from './modules/user';
import Vue from 'vue';
import Vuex from 'vuex';
import { IAction } from '@/types';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    about,
    accounts,
    catalog,
    mainPage,
    news,
    profile,
    renters,
    settings,
    toBusiness,
    user,
  },
});

const actionStack: IAction[] = [];

/*
  *NOTE: actions exclude all REST API (POST, PATH, DELETE, PUT) without GET,
  * where received translation for app
*/
const excludedAction: string[] = [
  'setUserLanguage',
  'rentApartment',
  'mergeNavigation',
  'showCentralAlert',
  'setNavigation',
  'accounts/login',
  'accounts/getGlobalPermissions',
  'accounts/verifyUserPhoneByCode',
  'accounts/confirm2FA',
  'accounts/resendLoginVerifyByPhoneCode',
  'accounts/resendRegistrationVerifyByPhoneCode',
  'accounts/createNewUser',
  'accounts/resetPassword',
  'accounts/sendPassword',
  'user/setUser',
  'user/loginByAccessToken',
  'user/updateUserEmail',
  'user/uploadUserImg',
  'user/updateUserData',
  'user/updateUserEmail',
  'user/updateUserPhone',
  'user/clearUserData',
  'user/userChangePassword',
  'profile/addStepNumber',
  'profile/cancelRentAd',
  'profile/clearNotifications',
  'profile/clearRentalPayments',
  'profile/clearComunalPayments',
  'profile/clearSupportData',
  'profile/clearStepNumber',
  'profile/createFeedback',
  'profile/createNewMessage',
  'profile/deleteLodgerFromApart',
  'profile/decrementStepNumber',
  'profile/pay',
  'profile/postFeedback',
  'profile/sendLodger',
  'profile/sendAdRequest',
  'profile/toggleFavorite',
  'toBusiness/sendData',
];

export type ConcurrentActions = Map<string, IAction>;

const concurrentAction: IAction[] = [
  {
    type: 'profile/clearNotifications',
  },
  {
    type: 'profile/clearRentalPayments',
  },
  {
    type: 'profile/clearComunalPayments',
  },
  {
    type: 'profile/clearApartmentPayments',
  },
  {
    type: 'profile/clearFeedbakList',
  },
];

export const mapedAction: ConcurrentActions = new Map();
concurrentAction.forEach((act) => {
  mapedAction.set(act.type, act);
});
const catchAction: string[] = [
  'profile/fetchNotifications',
  'profile/getRentPayments',
  'profile/getCommunalPayments',
  'profile/getApartmentPayments',
];

// this actions saved for toggling language, just save last query
const savedRequests: string[] = [
  'catalog/sendSearchData',
  'news/getNewsById',
  'news/getSimilarNewsById',
  'setStartDate',
  'setPeriodPickerValue',
  'updateActualSearchData',
];

function catchCuncurrency(action) {
  catchAction.some((item) => {
    if (item === action.type) {
      const newObj = JSON.parse(JSON.stringify(action));
      mapedAction.set(newObj.type + newObj.payload?.page, newObj);
    }
  });
}

store.subscribeAction({
  before: (action) => {
    catchCuncurrency(action);
    if (![...excludedAction, ...catchAction].some((item: string) => item === action.type)) {
      if (!actionStack.some((item) => item.type === action.type)) {
        actionStack.push(action);
      }
    }
    // store last action with query
    if (savedRequests.includes(action.type)) {
      const actn = actionStack.find((act) => act.type === action.type);
      if (!!actn) {
        actn.payload = action.payload;
      }
    }
  },
  after: async (action) => {
    if (action.type === 'setUserLanguage') {
      const stackLength = actionStack.length;
      for (let i = 0; i < stackLength; i++) {
        store.dispatch(actionStack[i].type, actionStack[i].payload);
      }
      for await (const value of mapedAction.values()) {
        store.dispatch(value.type, value.payload);
      }
    }
  },
});

export default store;
